import axios from '@/utils/api' // eslint-disable-line

const actions = {

  async getMessageNotification ({ commit }, idUser) {
    const data = await axios({
      method: 'get',
      url: `notifications/${idUser}/message`
    })
    return data
  },

  async isNotificacaoMessage ({ commit }, idUser) {
    const data = await axios({
      method: 'get',
      url: `notifications/${idUser}`
    })
    return data
  },

  async updatedNotification ({ commit }, idMessage) {
    const data = await axios({
      method: 'put',
      url: `notifications/${idMessage}`
    })
    return data
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications/notifications.js